<form *ngIf="casesTreatmentsFormGroup" [formGroup]="casesTreatmentsFormGroup">
    <p-card styleClass="p-3 p-card-content-pt-0 p-card-content-pb-0">

        <div class="grid">
            <div class="col-3 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="icon">Icono</label>
                <input pInputText formControlName="icon" d-form-field-error />
                <small>Revisar los iconos disponibles en https://primeng.org/icons</small>
            </div>
            <div class="col-3 input-field">
                <label for="backgroundColor">Color de fondo</label>
                <div class="flex gap-2">
                    <p-colorPicker [style.width]="'40px'" formControlName="backgroundColor" #backgroundColor d-form-field-error></p-colorPicker>
                    <input pInputText (change)="onColorChanged(backgroundColor)" [(ngModel)]="backgroundColor.inputBgColor" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
            <div class="col-3 input-field">
                <label for="foregroundColor">Color de texto</label>
                <div class="flex gap-2">
                    <p-colorPicker [style.width]="'40px'" formControlName="foregroundColor" #foregroundColor d-form-field-error></p-colorPicker>
                    <input pInputText (change)="onColorChanged(foregroundColor)" [(ngModel)]="foregroundColor.inputBgColor" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>

    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>